if (!customElements.get('mode-switch-image')) {
    customElements.define(
        'mode-switch-image',
        class ModeSwitchImage extends HTMLElement {
            constructor() {
                super();
                this.swiperInstance = null;
                this.swiperEl = this.querySelector('.swiper');
                this.switchEls = [];
                this.mainImageEls = [];
                this.container = null;
                this.scrollTrigger = null;

                this.handleClick = this.handleClick.bind(this);
                this.handleResize = this.handleResize.bind(this);
            }

            connectedCallback() {
                this.initSwiper();
                this.switchEls = Array.from(this.querySelectorAll('.mode-switch-image-content-switch'));
                this.mainImageEls = Array.from(this.querySelectorAll('.mode-switch-image-content-image'));
                this.container = this.querySelector('.mode-switch-image-content-container');

                this.checkDevice();
                window.addEventListener('resize', this.handleResize);
            }

            disconnectedCallback() {
                this.switchEls.forEach(item => {
                    item.removeEventListener('click', this.handleClick);
                });
                window.removeEventListener('resize', this.handleResize);
                if (this.scrollTrigger) {
                    this.scrollTrigger.kill();
                }
            }

            initSwiper() {
                if (!this.swiperEl) return;

                this.swiperInstance = new Swiper(this.swiperEl, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    allowTouchMove: false,
                });
            }

            checkDevice() {
                if (window.innerWidth > 1001) {
                    this.bindClickEvents();
                } else {
                    document.addEventListener('DOMContentLoaded', () => {
                        this.bindScrollEvents();
                    });
                }
            }

            handleResize() {
                this.checkDevice();
            }

            bindClickEvents() {
                this.switchEls.forEach((item, index) => {
                    item.dataset.index = index;
                    item.addEventListener('click', this.handleClick);
                });
            }

            handleClick(event) {
                const index = Number(event.currentTarget.dataset.index);
                this.switch(index);
            }

            switch(index) {
                if (!this.swiperInstance) return;
                this.swiperInstance.slideTo(index, 600);
                this.updateActiveSwitch(index);
            }

            updateActiveSwitch(index) {
                this.switchEls.forEach(item => item.classList.remove('active'));
                if (this.switchEls[index]) {
                    this.switchEls[index].classList.add('active');
                }
            }

            bindScrollEvents() {
                if (!this.container) return;

                const size = parseInt(this.dataset.size) || 1;

                if (this.scrollTrigger) {
                    this.scrollTrigger.kill();
                }

                var pinEl = this.querySelector('.mode-switch-image-content-container');
                // 获取root里的--header-height变量值，没有就是0
                const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height') || 0;
                // 获取this的上下边距 padding
                const elementSpacing = getComputedStyle(this).getPropertyValue('padding-top') || 0;
                const startTop = parseInt(headerHeight) + parseInt(elementSpacing) + 1;
                const initScrollTrigger = () => {
                    this.scrollTrigger = ScrollTrigger.create({
                        trigger: pinEl,
                        // start: "top top",
                        start: `top ${startTop}`,
                        end: "bottom top",
                        pin: true,
                        pinSpacing: true,
                        // markers: true,
                        scrub: 0.5,
                        onUpdate: (self) => {
                            const progress = self.progress;
                            const activeIndex = Math.min(Math.floor(progress * size), size - 1);
                            this.switch(activeIndex);
                        },
                        onEnter: () => this.switch(0),
                        onLeaveBack: () => this.switch(0),
                    });

                    window.scrollTT = this.scrollTrigger;
                };

                initScrollTrigger();
                let refreshCount = 0;
                this.refreshInterval = setInterval(() => {
                    this.refreshScrollTrigger();
                    refreshCount++;

                    if (refreshCount >= 5) {
                        clearInterval(this.refreshInterval);
                    }
                }, 800);
                this.triggerResizeOnEnterViewport(pinEl);
                this.switchEls.forEach(item => {
                    item.removeEventListener('click', this.handleClick);
                });
            }

            refreshScrollTrigger() {
                if (this.scrollTrigger) {
                    this.scrollTrigger.refresh();
                    // console.log("refreshed ScrollTrigger");
                }
            }

            triggerResizeOnEnterViewport(element) {
                if (!element) return;
            
                try {
                    // 1. 视口检测部分
                    const intersectionObserver = new IntersectionObserver((entries) => {
                        if (entries[0]?.isIntersecting) {
                            // console.log('元素进入视口，触发resize');
                            this.refreshScrollTrigger();
                            intersectionObserver.disconnect(); // 只触发一次
                        }
                    }, {
                        threshold: 0.1,
                        rootMargin: '50px'
                    });
            
                    // 2. 页面高度变化检测部分
                    let lastHeight = document.documentElement.scrollHeight;
                    const resizeObserver = new ResizeObserver(() => {
                        const currentHeight = document.documentElement.scrollHeight;
                        if (currentHeight !== lastHeight) {
                            // console.log('页面高度变化，触发resize');
                            this.refreshScrollTrigger();
                            lastHeight = currentHeight;
                        }
                    });
            
                    // 开始观察
                    intersectionObserver.observe(element);
                    resizeObserver.observe(document.body);
            
                } catch (error) {
                    console.error('Observer 初始化失败:', error);
                }
            }

        }
    );
}